import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetExpenseCategory_Result } from '@typeDefs/expenses/responses/expenses';
import { FileAttachmentGetList_Result, HRUser } from '@typeDefs/employee/responses/employee';
import { ApiResponse, ApiDataResponse } from '@shared/model/api-response.model';
import { ADGetUsersByPRCoAndPRGroup_Result } from '@typeDefs/admin/responses/admin';

@Injectable({
  providedIn: 'root',
})
export class EmployeeApiService {
  private readonly http = inject(HttpClient);

  getCategory(): Observable<GetExpenseCategory_Result[]> {
    const url = '/Employee/CatgGet';
    return this.http.get<GetExpenseCategory_Result[]>(url);
  }

  catgAddEdit(expenseCatgID: number, expenseCatgName: string, isActive: boolean): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgAddEdit', {
      expenseCatgID: expenseCatgID,
      expenseCatgName: expenseCatgName,
      isActive: isActive,
    });
  }

  checkForDuplicateCCs(searchText: string): Observable<ApiDataResponse<HRUser[]>> {
    const params = new HttpParams().set('lastFourCCDigits', searchText);
    return this.http.get<ApiDataResponse<HRUser[]>>('/Employee/CheckForDuplicateCCs', { params: params });
  }

  catgDelete(expenseCatgID: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgDelete', {
      expenseCatgID: expenseCatgID,
    });
  }

  getFileAttachmentBinary(fileAttachmentID: string) {
    const url = "/Employee/GetFileAttachmentBinary";
    const params = new HttpParams().set("fileAttachmentID", fileAttachmentID);
    return this.http.get<string>(url, { params: params });
  }

  getFileAttachmentList(requestParam: string) {
    const url = '/Employee/GetFileAttachmentList?' + requestParam;
    return this.http.get<FileAttachmentGetList_Result[]>(url);
  }

  getFileAttachmentData(fileAttachmentID: string): Observable<Blob> {
    const url = '/Employee/GetFileAttachmentData';
    const params = new HttpParams().set("fileAttachmentID", fileAttachmentID);

    return this.http.get(url, { params: params, responseType: 'blob' });
  }

  removeFileAttachment(fileAttachmentID: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/RemoveFileAttachment', {
      fileAttachmentID: fileAttachmentID,
    });
  }

  updateHRUser(user: ADGetUsersByPRCoAndPRGroup_Result): Observable<ApiDataResponse<{ matchingCCUsers: string }>> {
    return this.http.post<ApiDataResponse<{ matchingCCUsers: string }>>('/Employee/UpdateHRUser', user);
  }
}
